module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljirooraeorae-4@3x.jpg?e20fc229";